import React, {useEffect, useState} from "react";

const IsDesktop = () => {
    const [width, setWidth] = useState(window.innerWidth);
    const handleWindowSizeChange = () => {
            setWidth(window.innerWidth);
            if(window.innerWidth < 992){
                document.body.classList.add("menu-close");
            } 
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);
    return (width >= 992);
}

export default IsDesktop;